export default "__VITE_ASSET__3dca4a6c__"